import { render, staticRenderFns } from "./CustomFieldsEmptyMessageComponent.vue?vue&type=template&id=13867206&scoped=true&lang=pug"
import script from "./CustomFieldsEmptyMessageComponent.vue?vue&type=script&lang=ts"
export * from "./CustomFieldsEmptyMessageComponent.vue?vue&type=script&lang=ts"
import style0 from "./CustomFieldsEmptyMessageComponent.vue?vue&type=style&index=0&id=13867206&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13867206",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13867206')) {
      api.createRecord('13867206', component.options)
    } else {
      api.reload('13867206', component.options)
    }
    module.hot.accept("./CustomFieldsEmptyMessageComponent.vue?vue&type=template&id=13867206&scoped=true&lang=pug", function () {
      api.rerender('13867206', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customFields/CustomFieldsCustomFieldsEmptyMessage/CustomFieldsEmptyMessageComponent.vue"
export default component.exports